export default "__VITE_ASSET__Cfm6SUMP__"